<template>
  <div class="footer_nav">
    
    <div class="menu company">
      <img
        class="image"
        referrerpolicy="no-referrer"
        src="../assets/img/logo.png"
      />
      <div class="info_box">
        <div class="info_text"><span>地址：</span>浙江省杭州市西湖区西斗门路天堂软件园D幢</div>
        <div class="info_text"><span>电话：</span>0571-85330337</div>
        <div class="info_text"><span>邮箱：</span>huwei@huweigreen.com</div>
      </div>
      
      <div class="code_box">
        <div class="code_content">
          <img
            class="image"
            referrerpolicy="no-referrer"
            src="../assets/img/wx_account.png"
          />
          <span class="item" style="color: #132F59;">绿能派公众号</span>
        </div>
        <div class="code_content">
          <img
            class="image"
            referrerpolicy="no-referrer"
            src="../assets/img/mini_app.png"
          />
          <span class="item" style="color: #132F59;">绿能派小程序</span>
        </div>
      </div>
    </div>
    <div style="display: flex;">
      <div class="menu margin">
        <span class="label">互为产品</span>
        <div class="content">
          <span class="item" @click="go('/energyStorage')">新型储能</span>
          <span class="item" @click="go('/greenEnergy')">绿能派</span>
          <span class="item" @click="go('/greenEnergyExpert')">绿能专家</span>
        </div>
      </div>
      <div class="menu">
        <span class="label">企业介绍</span>
        <span class="item" @click="go('/about')">关于我们</span>
      </div>
    </div>
    <div class="beian"><a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2021039735号-5</a></div>
  </div>
  
</template>

<script>
import { useRouter } from 'vue-router'
import { reactive } from "vue";
export default {
  setup(){
    const router = useRouter()
    const state = reactive({
      partnerList: [
        {
          name: '万豪国际集团',
          logo: 'wh.png'
        },
        {
          name: '海外海集团',
          logo: 'hwh.png',
          href: 'http://www.haiwaihai.com/'
        },
        {
          name: '两淮控股集团',
          logo: 'lhkg.png'
        },
        {
          name: '首旅如家',
          logo: 'rj.png'
        },
        {
          name: '国家电网',
          logo: 'gjdw.png'
        },
        {
          name: '中国饭店协会',
          logo: 'cn_hotel_association.png'
        },
        {
          name: '浙江饭店业协会',
          logo: 'zjfdxh.png'
        },
        {
          name: '格雷斯精选酒店',
          logo: 'gls.png'
        },
      ]
    })
    const go = (e) => {
      router.replace(e)
    }
    return{
      state,
      go
    }
  }
};
</script>

<style lang="scss" scoped>
// $design-width: 1920;
// @function pxttrem($px) {
//   @return $px/$design-width*10+rem;
// }
.beian{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  height: 40px;
  text-align: center;
  line-height: 20px;
  a{
    color: #ccd3db;
    // background: #F4F4F4;
    padding: 5px 20px;
    border-radius: 5px;
    text-align: center;
  }
  a:hover{
    color: #ffffff;
    background: #1667ff;
  }
}
.footer_nav {
  display: flex;
  justify-content: space-between;
  position: relative;
  background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/index/dbbj.png) 0 0 no-repeat ;
  background-size: 100% 100%;
  width: 100%;
  height: 630px;
  padding: 100px 312px 0 200px;
  box-sizing: border-box;
  .logo {
    width: 60px;
    height: 66px;
    margin-right: 50px;
  }
  .menu {
    display: flex;
    flex-direction: column;
    .label {
      font-size: 24px;
      color: #132F59;
      padding-bottom: 60px;
      font-weight: bold;
      position: relative;
    }
    .label::after{
      content: '';
      width: 207px;
      height: 1px;
      background: #DEE3EC;
      opacity: 0.5;
      position: absolute;
      left: 0;
      top: 38px;
    }
    .content {
      display: flex;
      flex-direction: column;
    }
    .contents {
      display: flex;
      flex-direction: column;
      .item {
        padding-bottom: 8px;
      }
    }
    .item {
      font-size: 20px;
      line-height: 25px;
      color: #516686;
      padding-bottom: 40px;
      cursor: pointer;
    }
    .item:hover {
      color: #1667ff;
    }
    .partner_box {
      width: 480px;
      display: grid;
      margin-top: -25px;
      grid-template-columns: repeat(3, 1fr);
      .img {
        width: 140px;
        height: 55px;
        padding: 20px 20px 0;
        img {
          width: 140px;
          height: 55px;
        }
      }
    }
  }
  .company{
    >img{
      width: 230px;
      margin-bottom: 50px;
    }
  }
  .margin{
    margin-right: 252px;
  }
  .info_box{
    position: relative;
    margin-bottom: 30px;
  }
  .info_box::after{
    content: '';
    width: 520px;
    height: 1px;
    background: #DEE3EC;
    opacity: 0.5;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .info_text{
    font-size: 20px;
    color: #516686;
    line-height: 27px;
    text-align: left;
    font-style: normal;
    margin-bottom: 30px;
  }
  .code_box {
    display: flex;
    .code_content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-right: 40px;
      .image {
        width: 120px;
        height: 120px;
      }
      .item {
        font-size: 14px;
        color: #132F59;
      }
    }
  }
}

</style>